"use client";

import { useEffect } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";

interface ErrorCardProps {
  error: Error & { digest?: string };
  reset: () => void;
  /** German heading text */
  heading?: string;
  /** German description text */
  message?: string;
  /** If set, logs `console.error("[prefix] Fehler:", error)` */
  logPrefix?: string;
  /** Additional className on the outer Card (merged with defaults) */
  className?: string;
}

export function ErrorCard({
  error,
  reset,
  heading = "Etwas ist schiefgelaufen",
  message = "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  logPrefix,
  className,
}: ErrorCardProps) {
  useEffect(() => {
    const prefix = logPrefix ? `[${logPrefix}] Fehler:` : "Fehler:";
    console.error(prefix, error);
  }, [error, logPrefix]);

  return (
    <Card padding="lg" className={cn("max-w-lg mx-auto text-center mt-12", className)}>
      <div className="flex justify-center mb-4">
        <div className="rounded-full bg-red-100 p-3">
          <AlertTriangle className="h-8 w-8 text-red-600" />
        </div>
      </div>
      <h2 className="text-xl font-bold text-zinc-900 mb-2">{heading}</h2>
      <p className="text-zinc-500 mb-6">{message}</p>
      <Button onClick={reset} leftIcon={<RotateCcw className="h-4 w-4" />}>
        Erneut versuchen
      </Button>
    </Card>
  );
}
